import { render, staticRenderFns } from "./SourcesCardsView.vue?vue&type=template&id=5938d29a&scoped=true&"
import script from "./SourcesCardsView.vue?vue&type=script&lang=js&"
export * from "./SourcesCardsView.vue?vue&type=script&lang=js&"
import style0 from "./SourcesCardsView.vue?vue&type=style&index=0&id=5938d29a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5938d29a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VPagination,VProgressCircular})
